import PropTypes from 'prop-types';

import ActuarialMode from './actuarial';
import ClassifierMode from './classifier';

export default function ModelCompare(props) {
  /* eslint-disable react/destructuring-assignment */
  if (props.modelClass === 'classifier') return ClassifierMode(props);
  if (props.modelClass === 'actuarial') return ActuarialMode(props);
  /* eslint-enable */
  return null;
}

ModelCompare.propTypes = {
  modelClass: PropTypes.string.isRequired,
};
